import React from 'react'
import MuiTable from '../../../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_CAMIONES_ENTRE_BRUTO_Y_DESTARE } from '../../../../../../config/tables'

export default function TablaCamionesEntreBrutoYDestareView () {
  return <MuiTable id={TABLA_CAMIONES_ENTRE_BRUTO_Y_DESTARE} />
}
